import React, { useState, useEffect } from 'react'
import Button from './button'
import toast from '../utils/toast';
import useUserStore from '../store/useUserStore';
import useMensagem from '../hooks/useMensagem';

export default function SendWarning({ text, number }) {
    const userStore = useUserStore();
    const usuario = userStore.usuario;
    const [alreadySent, setAlreadySent] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const { sendWarnigForAutoescola } = useMensagem();

    // Carregar status do localStorage ao montar o componente
    useEffect(() => {
        const storageKey = `aviso_enviado_${usuario.usuario_id}_${text}`;
        const jaEnviado = localStorage.getItem(storageKey);
        if (jaEnviado) {
            setAlreadySent(true);
        }
    }, [usuario.usuario_id, text]);

    const send = async () => {
        // Prevenir múltiplos cliques
        if (alreadySent || isSending) {
            return;
        }

        const message = `O aluno ${usuario.nome} ${usuario.sobrenome} (id: ${usuario.usuario_id}) está solicitando um ${text} para a aula. Por favor, regularize essa situação o mais rápido possível no sistema ou nos contate!`;
        
        setIsSending(true);

        try {
            //console.log('Enviando aviso:', message);
            const response = await sendWarnigForAutoescola(message, usuario.usuario_id);
            if (!response.success) {
                throw new Error(response.error || 'Erro ao enviar aviso');
            }
            toast.dismiss();
            await new Promise(resolve => setTimeout(resolve, 1000));
            
            // Armazenar no localStorage que o aviso foi enviado
            const storageKey = `aviso_enviado_${usuario.usuario_id}_${text}`;
            localStorage.setItem(storageKey, JSON.stringify({
                enviado: true,
                data: new Date().toISOString(),
                tipo: text
            }));
            
            setAlreadySent(true);
            setIsSending(false);
            toast.success(`Aviso para ${text} enviado! Aguarde o retorno da autoescola.`, { position: 'top-center' });
        } catch (error) {
            setIsSending(false);
            toast.dismiss();
            toast.error(`Erro ao enviar aviso para ${text}. Tente novamente mais tarde.`, { position: 'top-center' });
            return;
        }
    }

    return (
        <div>
            <div className={`${alreadySent ? 'bg-blue-800' : 'bg-red-800'} text-white p-4 rounded-md mb-4 gap-2 flex flex-col items-center justify-center transition-colors duration-300`}>
                <h2 className='text-lg font-semibold mb-2'>
                    {alreadySent ? `Solicitação de ${text} em andamento` : `Solicite um ${text} para aula`}
                </h2>
                <p>
                    {alreadySent 
                        ? 'Sua solicitação já foi enviada! A autoescola está analisando e resolverá em breve. Obrigado!' 
                        : 'Clique aqui que a autoescola irá receber um aviso para regulamentar esse processo o quanto antes!'}
                </p>
                <Button 
                    type={alreadySent ? 3 : 2} 
                    onClick={send}
                    disabled={alreadySent || isSending}
                    style={{ opacity: alreadySent || isSending ? 0.6 : 1, cursor: alreadySent || isSending ? 'not-allowed' : 'pointer' }}
                >
                    {isSending ? 'Enviando...' : alreadySent ? 'Aguardando resolução' : 'Enviar aviso'}
                    <span className="material-icons">
                        {alreadySent ? 'hourglass_empty' : 'warning'}
                    </span>
                </Button>
            </div>
        </div>
    )
}
